import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
  Alert,
} from "@mui/material";
import { FormattedMessage } from "react-intl";

interface DeletePriceDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  error: string | null;
}

const DeletePriceDialog: React.FC<DeletePriceDialogProps> = ({
  open,
  onClose,
  onConfirm,
  error,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <FormattedMessage id="admin.dashboard.deletePriceConfirmTitle" />
      </DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            <FormattedMessage id={error} />
          </Alert>
        )}
        <DialogContentText>
          <FormattedMessage id="admin.dashboard.deletePriceConfirmMessage" />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          <FormattedMessage id="admin.dashboard.cancel" />
        </Button>
        <Button onClick={onConfirm} variant="contained" color="error">
          <FormattedMessage id="admin.dashboard.confirm" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeletePriceDialog;
